export const ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN.replace(/"/g, '');;
export const MOBILE_WIDTH_THRESHOLD = 500;
export const getDirectionsURI = (origin, destination) =>
  `https://api.mapbox.com/directions/v5/mapbox/driving/${origin};${destination}?steps=true&geometries=geojson&access_token=${ACCESS_TOKEN}`